import { makeStyles } from '@material-ui/core/styles';
import { getFilterFooterBorderColor } from 'UI/theme/darkTones';

export const useStyles = makeStyles(
  theme => ({
    // The calendar renders inside a portaled MUI Popper (anchored to the trigger)
    // so it escapes ancestor `overflow: hidden` and auto-repositions on-screen.
    popper: {
      zIndex: theme.zIndex.modal
    },
    dateRangeContainer: {
      boxShadow: '1px 1px 81px rgba(41,60,74,.18)',
      backgroundColor: theme.palette.background.paper,
      borderRadius: 5
    },
    dateRangeToolbar: {
      display: 'flex',
      justifyContent: 'flex-end',
      borderTop: `1px solid ${getFilterFooterBorderColor(theme)}`,
      padding: 15
    }
  }),
  { name: 'DateRange' }
);
